import { BaseHandbook } from './Base/BaseHandbook';

/**
 * Периодичность<para/>
 * Periodicity
 */
export class Periodicity extends BaseHandbook {
    /**
     * Идентификатор Талдау<para/>
     * Taldau identifier
     */
    TaldauId: number = 0;
    /**
     * Специальный формат отображения этого периода<para/>
     * Special format of displaying that period
     */
    DisplayFormat: string = '';
}